import React from 'react';

import { ReactComponent as ArrowIcon } from '@assets/img/icons/arrow-down-class.svg';

import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

const NibAsyncAutoComplete = ({
  value = null,
  onChange = () => {},
  label = '',
  options = [],
  required = false,
  loading = false,
  handleInput = () => {},
  helperText = false,
  placeholder = '',
  error = false,
  wrapperProps,
  inputProps,
  ...props
}) => {
  const handleSelection = (val) => {
    onChange(val);
  };

  return (
    <Autocomplete
      options={options}
      onChange={(e, val) => handleSelection(val)}
      autoHighlight
      getOptionLabel={(option) => option.name || ''}
      getOptionSelected={(option, value) => option.id === value.id}
      loading={loading}
      loadingText={<CircularProgress color={'primary'} />}
      value={value}
      popupIcon={
        <span className="[&>svg]:!m-0 [&>svg]:!relative">
          <ArrowIcon />
        </span>
      }
      renderOption={(option) => <React.Fragment>{option.name}</React.Fragment>}
      renderInput={(params) => (
        <TextField
          {...params}
          error={error}
          required={required}
          size="small"
          label={label}
          variant="outlined"
          onChange={(e) => handleInput(e.target.value)}
          placeholder={placeholder}
          helperText={helperText}
          inputProps={{
            ...params.inputProps,
            autoComplete: 'off', // disable autocomplete and autofill
            ...props,
          }}
          {...inputProps}
        />
      )}
      {...wrapperProps}
      {...props}
    />
  );
};

export default NibAsyncAutoComplete;
